module.exports = __webpack_public_path__ + "img/forgetPass2.a7b66bee.png";